import React from 'react'
import './styles.scss'
import { config } from './config'
import { levelNames, hazardNames, languageType, localesInterface } from 'components/main/types'
interface Props {
  locales: localesInterface
}

export const HazardLevels = ({ locales }: Props) => (
  <div className='leveltablewrapper'>
    <div className='leveltabletitle'>{locales.other.titleLevels}</div>
    <table className='leveltable'>
      <tbody>
        {Object.keys(config.colors.hazards).map((hazard, i) => {
          return (
            <React.Fragment key={i}>
              {i == 0 && (
                <tr>
                  <td className='icontd'>&nbsp;</td>
                  {Object.keys(config.colors.hazards.water).map((l, i) => (
                    <td key={i}>{locales.levels[l as levelNames]}</td>
                  ))}
                </tr>
              )}
              <tr>
                <td rowSpan={2} className='icontd'>
                  <img src={require('images/icons_' + hazard + '_blue.svg')} />
                </td>
                <td className={'hazard' + (i === 0 ? ' f' : '')} colSpan={3}>
                  {locales.hazards[hazard as hazardNames]}
                </td>
              </tr>
              <tr>
                {Object.keys(config.colors.hazards[hazard]).map((l, j) => {
                  return (
                    <td key={j}>
                      <div
                        className='swatch'
                        style={{
                          backgroundColor: config.colors.hazards[hazard][l]
                        }}
                      ></div>
                    </td>
                  )
                })}
              </tr>
            </React.Fragment>
          )
        })}
      </tbody>
    </table>
  </div>
)
